import { render, staticRenderFns } from "./EmailField.vue?vue&type=template&id=18d30f27&scoped=true"
import script from "./EmailField.vue?vue&type=script&lang=js"
export * from "./EmailField.vue?vue&type=script&lang=js"
import style0 from "./EmailField.vue?vue&type=style&index=0&id=18d30f27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d30f27",
  null
  
)

export default component.exports